// extracted by mini-css-extract-plugin
export default {"container":"Home_container__M9Gpi","header":"Home_header__fs5p-","loading":"Home_loading__6JjqC","characters":"Home_characters__Xvx0d"};